import {Toast, toastStore} from 'common/components/toast-area';

export function clearAllToasts(): void {
  toastStore.clearAll();
}

export function addToast(toast: Toast): Toast {
  return toastStore.add(toast);
}

export function closeToast(toast: Toast): void {
  toastStore.close(toast);
}
